require('../customer/components/checkoutCustomerService');

$('.js-show_invoice_fields').on('click', function (e) {
    $('.js-invoice_address_container').removeClass('hidden');
    const form = $('.registration-form');
    form.find('[type=submit]').attr('disabled', false);
    $(this).parent().remove();
});

const SALE_IFRAME = document.getElementById('mijn-goossens-iframe');

function getIframeSrc(iframe) {
    const CURRENT_IFRAME_URL = new URL(iframe.dataset.src);
    const CURRENT_URL_PARAMS = new URLSearchParams(window.location.search)

    if (CURRENT_URL_PARAMS.get('scene') === "retour") {
        CURRENT_IFRAME_URL.searchParams.set('scene', 'retour');
    }

    iframe.setAttribute('src', CURRENT_IFRAME_URL);
}

if (SALE_IFRAME) {
    getIframeSrc(SALE_IFRAME);
}